export class Identifier<T> {
  constructor(private value: T) {
    this.value = value
  }

  equals(id?: Identifier<T>): boolean {
    if (id === undefined) {
      return false
    }
    if (!(id instanceof this.constructor)) {
      return false
    }
    return id.toValue() === this.value
  }

  notEquals(id?: Identifier<T>): boolean {
    if (id === undefined) {
      return true
    }
    if (!(id instanceof this.constructor)) {
      return true
    }
    return id.toValue() !== this.value
  }

  toString(): string {
    return String(this.value)
  }

  /**
   * Return raw value of identifier
   */

  toValue(): T {
    return this.value
  }
}
